import React from 'react';
import { WrenchIcon, DropletIcon, ZapIcon } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Dizel Motor Bakımı',
    description: 'Uzman ekibimizle periyodik bakım ve arıza tespiti.',
    icon: <WrenchIcon className="w-8 h-8 text-green-500" data-id="element-173" />
  }, {
    title: 'Enjektör Temizliği',
    description: 'Yakıt verimliliği ve performans için profesyonel temizlik.',
    icon: <DropletIcon className="w-8 h-8 text-green-500" data-id="element-174" />
  }, {
    title: 'Arıza Teşhisi',
    description: 'Modern cihazlarla hızlı ve doğru arıza tespiti.',
    icon: <ZapIcon className="w-8 h-8 text-green-500" data-id="element-175" />
  }];
  return <section id="hizmetler" className="py-16 bg-gray-50" data-id="element-176">
      <div className="container mx-auto px-4" data-id="element-177">
        <div className="text-center mb-12" data-id="element-178">
          <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-179">
            Hizmetlerimiz
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-180">
          {services.map((service, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition" data-id="element-181">
              <div className="mb-4" data-id="element-182">{service.icon}</div>
              <h3 className="text-xl font-bold text-green-500 mb-3" data-id="element-183">
                {service.title}
              </h3>
              <p className="text-gray-600" data-id="element-184">{service.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}